export enum NotificationTypes {
  feedback = "feedback",
  like = "like",
  reply = "reply",
  badge = "badge",
}

export interface Notification {
  type: NotificationTypes;
  solutionId: string;
  solutionTitle?: string;
  senderUid: string;
  senderPicture: string;
  updatedAt?: number;
  seen?: boolean;
  userId?: string;
  username?: string;
  badgeName?: string;
}

export interface Notifications {
  notifications: Notification[];
  uid: string;
}
